export type InvoiceLineVisibility = {
  customerVisible?: boolean | number | null;
  sourceDisplayInAmount?: boolean | number | null;
  sourceItemType?: string | null;
  sourceIsChargeable?: boolean | number | null;
};

/** Mirrors ServiceTitan's invoice print rule for hidden bundle components and internal materials. */
export function isCustomerVisibleInvoiceLine(line: InvoiceLineVisibility) {
  if (line.customerVisible !== undefined && line.customerVisible !== null) return Boolean(line.customerVisible);
  if (line.sourceDisplayInAmount !== undefined && line.sourceDisplayInAmount !== null && Number(line.sourceDisplayInAmount) === 0) return false;
  return !(line.sourceItemType === "Material" && Number(line.sourceIsChargeable) === 0);
}

export function hiddenInvoiceLineReason(line: InvoiceLineVisibility) {
  if (isCustomerVisibleInvoiceLine(line)) return null;
  return Number(line.sourceDisplayInAmount) === 0
    ? "Hidden membership bundle component from ServiceTitan"
    : "Non-chargeable material from ServiceTitan";
}
